// src/components/Navbar.js
import React, { useState } from 'react';
import './Navbar.css';
import { FaShoppingBag, FaSearch, FaBars, FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [menuActive, setMenuActive] = useState(false);

  const toggleMenu = () => {
    setMenuActive(!menuActive);
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <div className="logo-box">Trip</div>
        Wise Travel
      </div>

      <ul className={`navbar-links ${menuActive ? 'active' : ''}`}>
        <li><Link to="/" className="active">Home</Link></li>
        <li><Link to="/destinations">Destinations</Link></li>
        <li><Link to="/tours">Tours</Link></li>
        <li><Link to="/contact">Contact</Link></li>
      </ul>

      <div className="navbar-icons">
        <FaShoppingBag className="icon" />
        <FaSearch className="icon" />
        <div className="menu-toggle" onClick={toggleMenu}>
          {menuActive ? <FaTimes /> : <FaBars />}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
